/**
 * Journée d'un paquet principal : elle commence à son heure de début de journée, en heure
 * locale (ADR 0010). Deux paquets peuvent donc changer de jour à des heures différentes.
 */

/** Début de la journée du paquet qui contient `instant`. */
export function debutJournee(instant: Date, heureDebut: number): Date {
  const debut = new Date(instant);
  debut.setHours(heureDebut, 0, 0, 0);
  if (debut.getTime() > instant.getTime()) debut.setDate(debut.getDate() - 1);
  return debut;
}

/** Fin (exclue) de la journée du paquet qui contient `instant`. */
export function finJournee(instant: Date, heureDebut: number): Date {
  const fin = debutJournee(instant, heureDebut);
  fin.setDate(fin.getDate() + 1);
  return fin;
}

/** Les deux instants tombent-ils dans la même journée du paquet ? */
export function memeJournee(a: Date, b: Date, heureDebut: number): boolean {
  return debutJournee(a, heureDebut).getTime() === debutJournee(b, heureDebut).getTime();
}
